var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-info-wrapper" }, [
    _c(
      "ul",
      {
        staticClass: "accordion accordion-customize",
        attrs: {
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
          id: "company-info-accordion",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("company.titles.companyInfo"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { "data-tab-content": "" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "small-4 medium-4 large-4 column" },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("company.basic.basicInfo"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column-wrapper" }, [
                        _c("div", { staticClass: "input-set" }, [
                          _c(
                            "label",
                            {
                              class: [
                                "emphasis",
                                {
                                  "required-flag":
                                    _vm.allowEdit && _vm.editable,
                                },
                              ],
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("company.basic.companyName"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.allowEdit && _vm.editable
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "string",
                                      tip: _vm.$t("hint.inputTip.string"),
                                      classes: "tooltip-class",
                                    },
                                    expression:
                                      "{\n                    type: 'string',\n                    tip: $t('hint.inputTip.string'),\n                    classes: 'tooltip-class'\n                  }",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  disabled: _vm.currentCompany.id,
                                  required: "",
                                },
                                domProps: {
                                  value: _vm.deep(_vm.currentCompany, "name"),
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updatePathField(
                                      "name",
                                      event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.allowEdit && _vm.editable)
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.currentCompany.name)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-set" }, [
                          _c("label", { staticClass: "emphasis" }, [
                            _vm._v(_vm._s(_vm.$t("company.basic.mailingName"))),
                          ]),
                          _vm._v(" "),
                          _vm.allowEdit && _vm.editable
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.deep(
                                    _vm.currentCompany,
                                    "mailingName"
                                  ),
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updatePathField(
                                      "mailingName",
                                      event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.allowEdit && _vm.editable)
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.currentCompany.mailingName || "--")
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-set" }, [
                          _c("label", { staticClass: "emphasis" }, [
                            _vm._v(
                              _vm._s(_vm.$t("company.basic.parentCompany"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.allowEdit && _vm.editable
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.deep(
                                    _vm.currentCompany,
                                    "parentName"
                                  ),
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updatePathField(
                                      "parentName",
                                      event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.allowEdit && _vm.editable)
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.currentCompany.parentName || "--")
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row input-set" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-6 medium-6 large-6 column sub-column",
                            },
                            [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(_vm._s(_vm.$t("company.basic.status"))),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("HKLSelect", {
                                    attrs: {
                                      value:
                                        _vm.valueForStatusSelected || undefined,
                                      options: _vm.companyStatusHklOptions,
                                      showSearch: true,
                                      placeholder: "",
                                    },
                                    on: { change: _vm.updateCompanyStatus },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customStatusLabel(
                                          _vm.valueForStatusSelected
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-6 medium-6 large-6 column sub-column",
                            },
                            [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("company.basic.companyType"))
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: { type: "text", disabled: "" },
                                    domProps: {
                                      value:
                                        _vm.deep(_vm.currentCompany, "type") ||
                                        "O",
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updatePathField(
                                          "type",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(_vm._s(_vm.currentCompany.type)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "small-8 medium-8 large-8 column",
                      class: {
                        "error-highlight-background": _vm.inputRequireHighlight,
                      },
                    },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("company.contact.contactInfo"))),
                        _vm.allowEdit && _vm.editable
                          ? _c(
                              "span",
                              {
                                staticClass: "label-tip",
                                class: {
                                  "error-highlight": _vm.inputRequireHighlight,
                                },
                              },
                              [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.$t("company.contact.contactInfoTip")
                                    ) +
                                    ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row column-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "small-5 medium-5 large-5 column" },
                          [
                            _c("div", { staticClass: "input-set" }, [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("company.contact.phoneNumber"))
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "string",
                                          pattern: _vm.regex.phone,
                                          classes: "tooltip-class",
                                          tip: _vm.tips.phone,
                                          required: _vm.deep(
                                            _vm.currentCompany,
                                            "phone"
                                          ),
                                        },
                                        expression:
                                          "{\n                      type: 'string',\n                      pattern: regex.phone,\n                      classes: 'tooltip-class',\n                      tip: tips.phone,\n                      required: deep(currentCompany, 'phone')}",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "phone"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "phone",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.currentCompany.phone || "--")
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("company.contact.alterPhoneNumber")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "string",
                                          pattern: _vm.regex.phone,
                                          classes: "tooltip-class",
                                          tip: _vm.tips.phone,
                                          required: _vm.deep(
                                            _vm.currentCompany,
                                            "altPhone"
                                          ),
                                        },
                                        expression:
                                          "{\n                      type: 'string',\n                      pattern: regex.phone,\n                      classes: 'tooltip-class',\n                      tip: tips.phone,\n                      required: deep(currentCompany, 'altPhone')}",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "altPhone"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "altPhone",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentCompany.altPhone || "--"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(_vm._s(_vm.$t("company.contact.fax"))),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "fax"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "fax",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.currentCompany.fax || "--")
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(_vm._s(_vm.$t("company.contact.email"))),
                              ]),
                              _vm._v(" "),
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                      {
                                        name: "fusioninputcheck",
                                        rawName: "v-fusioninputcheck",
                                        value: {
                                          type: "string",
                                          pattern: _vm.regex.email,
                                          classes: "tooltip-class",
                                          tip: _vm.tips.email,
                                          required: _vm.deep(
                                            _vm.currentCompany,
                                            "email"
                                          ),
                                        },
                                        expression:
                                          "{\n                      type: 'string',\n                      pattern: regex.email,\n                      classes: 'tooltip-class',\n                      tip: tips.email,\n                      required: deep(currentCompany, 'email')}",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "email"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "email",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.currentCompany.email || "--")
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "small-7 medium-7 large-7 column" },
                          [
                            _c("label", { staticClass: "emphasis" }, [
                              _vm._v(
                                _vm._s(_vm.$t("company.contact.addressLine"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "company.contact.addressLine1"
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "address1"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "address1",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isEmpty(
                                          _vm.currentCompany.address1
                                        )
                                          ? _vm.currentCompany.address1
                                          : "--"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "company.contact.addressLine2"
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "address2"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "address2",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isEmpty(
                                          _vm.currentCompany.address2
                                        )
                                          ? _vm.currentCompany.address2
                                          : "--"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "company.contact.addressLine3"
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "address3"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "address3",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isEmpty(
                                          _vm.currentCompany.address3
                                        )
                                          ? _vm.currentCompany.address3
                                          : "--"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-set" }, [
                              _vm.allowEdit && _vm.editable
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "hkldinput",
                                        rawName: "v-hkldinput",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "company.contact.addressLine4"
                                      ),
                                    },
                                    domProps: {
                                      value: _vm.deep(
                                        _vm.currentCompany,
                                        "address4"
                                      ),
                                    },
                                    on: {
                                      change: function (event) {
                                        return _vm.updateContactInfoPathField(
                                          "address4",
                                          event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.allowEdit && _vm.editable)
                                ? _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isEmpty(
                                          _vm.currentCompany.address4
                                        )
                                          ? _vm.currentCompany.address4
                                          : "--"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row remark-row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "small-12 medium-12 large-12 column input-set",
                    },
                    [
                      _c("label", { staticClass: "emphasis" }, [
                        _vm._v(_vm._s(_vm.$t("company.remarks"))),
                      ]),
                      _vm._v(" "),
                      _vm.allowEdit
                        ? _c("textarea", {
                            directives: [
                              { name: "hkldinput", rawName: "v-hkldinput" },
                              { name: "autosize", rawName: "v-autosize" },
                            ],
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.deep(_vm.currentCompany, "remarks"),
                            },
                            on: {
                              change: function (event) {
                                return _vm.updatePathField(
                                  "remarks",
                                  event.target.value
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.allowEdit
                        ? _c("pre", [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.currentCompany.remarks || "--")
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }